export default {
      id: "areas-3-usage",
      viewBox: "0 0 26 26",
      url: "/" + "assets/sprite.svg#areas-3",
      toString: function () {
        return this.url;
      }
    }